import axios from 'axios'
import { useServiceStore } from '../composables/serviceStore'

const API_URL = import.meta.env.VITE_API_URL as string

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Inject X-Hotel-Code on every request originating from services
apiClient.interceptors.request.use((config) => {
  try {
    const serviceStore = useServiceStore()
    const hotelId = serviceStore?.serviceId
    if (hotelId) {
      config.headers = config.headers ?? {}
      ;(config.headers as any)['X-Hotel-Code'] = String(hotelId)
    }
  } catch (e) {
    // non-fatal: if store not available, skip header injection
  }
  return config
})

// Also inject X-Hotel-Code for direct axios calls (not using apiClient)
axios.interceptors.request.use((config) => {
  try {
    const serviceStore = useServiceStore()
    const hotelId = serviceStore?.serviceId
    if (hotelId) {
      config.headers = config.headers ?? {}
      ;(config.headers as any)['X-Hotel-Code'] = String(hotelId)
    }
  } catch (e) {
    // non-fatal: if store not available, skip header injection
  }
  return config
})

// Response interceptor for 429 rate limit handling
apiClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    const status = err?.response?.status
    const retryAfter = Number(
      err?.response?.headers?.['retry-after'] ??
        err?.response?.data?.retry_after_seconds ??
        0,
    )
    if (status === 429) {
      if (Number.isFinite(retryAfter) && retryAfter > 0) {
        window.dispatchEvent(
          new CustomEvent('mfa:rate-limit', { detail: { retryAfter } }),
        )
      }
      return Promise.reject(err)
    }
    return Promise.reject(err)
  },
)

export default apiClient
